import { addStaticRootToUrl } from "@src/utils/static";
import React from "react";

interface ProductImageProps {
  className?: string;
  imageSrc?: string;
  imageAlt?: string;
  sizePx?: number;
}

export default function ProductImage({
  className,
  imageSrc = addStaticRootToUrl("images/placeholders/image_na.png"),
  imageAlt = "Product image",
  sizePx = 100,
}: ProductImageProps) {
  const baseSizingStyles = {
    width: `${sizePx}px`,
    height: `${sizePx}px`,
  };

  return (
    <div className={className} style={baseSizingStyles}>
      <img
        style={{
          ...baseSizingStyles,
          objectFit: "contain",
        }}
        src={imageSrc}
        alt={imageAlt}
      />
    </div>
  );
}
